var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"figureHolder",attrs:{"id":"userFigureComponent"}},[_c('div',{ref:"userAvatar",style:(_vm.backgroundImage),attrs:{"alt":_vm.userData.name}})])
}
var staticRenderFns = []

export { render, staticRenderFns }